import VerticalTab from './vertical-tab';
import './vertical-tab.scss';

export default VerticalTab;
